/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Section_PlansInputs */



/**
* | output |
* | --- |
* | "Plans & Pricing" |
*
* @param {Faq_Section_PlansInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const faq_section_plans = /** @type {((inputs?: Faq_Section_PlansInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Section_PlansInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Pläne & Preise")
	return /** @type {LocalizedString} */ ("Plans & Pricing")
});